<template>
  <div class="formulator-input__container">
    <div
      id="formulator-input"
      class="formulator-input"
    >
      <div class="formulator-input__header">
        <h2 class="formulator-input__title">
          <span>Formula tu alimento balanceado</span>
        </h2>
        <div class="input__tabs">
          <div
            v-for="tab in filteredTabs"
            v-html="tab.label"
            :key="`tab-${tab.id}`"
            class="input__tab"
            @click="setSelectedTab(tab.id)"
            :class="selectedTab === tab.id ? 'input__tab--active' : 'input__tab--inactive'"
          />
        </div>
      </div>
      <div class="input__restrictions">
        <div
          class="restriction__high-precision"
          v-if="selectedTab === 'high-precision'"
        >
          <formulator-high-precision />
        </div>
        <div
          class="restriction__nutritional"
          v-if="selectedTab === 'nutritional'"
        >
          <formulator-nutrition />
        </div>
        <div
          class="restriction__ingredient"
          v-if="selectedTab === 'ingredient'"
        >
          <formulator-ingredients />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import formulatorNutrition from './formulator-nutrition';
import formulatorIngredients from './formulator-ingredients.vue';
import formulatorHighPrecision from './formulator-high-precision.vue';

export default {
  components: {
    formulatorNutrition,
    formulatorIngredients,
    formulatorHighPrecision,
  },
  props: {
    enabledCncpsFormulator: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    setSelectedTab(tabName) {
      this.$store.commit('setSelectedTab', tabName);
    },
    openInfo(infoModal) {
      this.$modal.show(infoModal);
    },
    setDefaultTab() {
      let form = 'nutritional';
      if (this.highPrecisionEnabled) {
        form = 'high-precision';
      } else if (this.isCoagraWeb) {
        form = 'ingredient';
      }
      this.setSelectedTab(form);
    },
  },
  computed: {
    selectedTab() {
      return this.$store.state.formulator.selectedTab;
    },
    tabs() {
      return [
        { id: 'high-precision', label: 'Alta <br/> precisión', active: this.highPrecisionEnabled },
        { id: 'nutritional', label: 'Restricciones nutricionales', active: !this.isCoagraWeb },
        { id: 'ingredient', label: 'Restricción ingredientes', active: true },
      ];
    },
    filteredTabs() {
      return this.tabs.filter(tab => tab.active);
    },
    highPrecisionEnabled() {
      return this.enabledCncpsFormulator && this.loggedIn;
    },
    loggedIn() {
      return this.$store.state.loggedIn;
    },
    isCoagraWeb() {
      return this.$store.state.order.isCoagraWeb;
    },
  },
  mounted() {
    const activeTabIds = this.filteredTabs.map(tab => tab.id);
    if (!this.selectedTab || !activeTabIds.includes(this.selectedTab)) {
      this.setDefaultTab();
    }
  },
};
</script>

<style scoped>
p {
  font-size: 2em;
  text-align: center;
}
</style>
